// 不根据 UA 或 localhost 推断：Android 浏览器不属于原生 App。
export const isNativeAndroid = () => Boolean(window.cordova && window.cordova.platformId === 'android')
